import { createContext, useCallback, useContext, useEffect, useState, } from "react";
import { getUser, isTokenExpired, refreshToken } from "../utils/TokenUtils";

const AuthContext = createContext();
const CHECK_TOKEN_INTERVAL = 25;

export const AuthProvider = ({children}) => {
    const [auth, setAuth] = useState(!!localStorage.getItem('_token'));
    const [user, setUser] = useState(null);

    const logout = useCallback(() => {
        localStorage.removeItem('_token');
        setUser(null);
        setAuth(false)
    }, []) 

    const checkToken = useCallback( async() => { 
        const token = localStorage.getItem('_token');
        if(token) {
            if(isTokenExpired(token)){
                console.log("Token expired, attempting to refresh...");
                try{
                    await refreshToken();
                    const refreshedToken = localStorage.getItem('_token');
                    if (refreshedToken && !isTokenExpired(refreshedToken)) {
                        console.log("Token refreshed successfully.");
                        const userData = await getUser();
                        setUser(userData);
                        setAuth(true);
                    } else {
                        console.error("Failed to refresh token or token still invalid.");
                        logout();
                    }
                }catch(error){

                }
            }else{
                const userData = await getUser();
                setUser(userData);
                setAuth(true);
            }
        }else{
            setAuth(false)
            logout();
        }
    }, [logout])

    useEffect(() => {
        checkToken();
        const interval = setInterval(checkToken, CHECK_TOKEN_INTERVAL * 60 * 1000)
        return () => clearInterval(interval);
    }, [checkToken]);
    

    const login = async(token) => {
        localStorage.setItem('_token', token);
        const userData = await getUser();
        setUser(userData)
        setAuth(true)
    }
    return (
        <AuthContext.Provider value={{ auth, login, logout, user }}>
            {children}
        </AuthContext.Provider>
    )
}
export const useAuth = () => useContext(AuthContext);